var api = require("!../../../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../../node_modules/css-loader/dist/cjs.js??ref--3-1!../../../../../../../node_modules/vue-loader/dist/stylePostLoader.js!../../../../../../../node_modules/postcss-loader/src/index.js??ref--3-2!../../../../../../../node_modules/vue-loader/dist/index.js??ref--15-0!./ProductPage.vue?vue&type=style&index=0&id=2e6c103d&scoped=true&lang=css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};